import axios from 'axios'
import { API_URL, getAuthHeader } from '@/services/api.service.js'
import { logger } from '@/utils/logger'

/**
 * Fetch latest forex rates
 * @returns {Promise<{ rates, base }>} forex rates
 */
export async function getForexRates() {
  try {
    const ret = await axios.get(`${await API_URL()}/forex/latest`, {
      headers: { ...(await getAuthHeader()) }
    })

    if (ret.status === 200) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.info(error)
    return null
  }
}
